import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { IconAccess, IconAlarm, IconWarn, IconZoom } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo4.mp4';
import subVideo5 from '@src/assets/images/solution/constructionAsset/video/sub/rtlsVideo5.mp4';

export default {
  banner: {
    title: 'Quản lý vật tư xây dựng',
    desc: 'Quản lý vật tư xây dựng chính xác là yếu tố then chốt để nâng cao năng suất. Việc theo dõi vị trí vật tư không chỉ giúp giảm thiểu lãng phí tài nguyên và duy trì chất lượng, mà còn có tầm quan trọng đến mức ảnh hưởng trực tiếp đến an toàn tại công trường xây dựng.',
  },

  video: {
    title: 'Quản lý vật liệu chính xác và nhanh chóng.',
    desc: 'Cung cấp vị trí vật liệu theo thời gian thực, giúp tìm kiếm gần như ngay lập tức.<br/>Hệ thống cung cấp thông tin vị trí vật liệu theo thời gian thực, gần như không tốn thời gian để tìm kiếm.<br/>Bên cạnh đó, khả năng quản lý cả số lượng vật tư sẽ mang lại một đẳng cấp <strong>năng suất vượt trội</strong> so với giai đoạn trước khi ứng dụng công nghệ RTLS này.',
    play: video,
  },

  func: [
    {
      title: 'Quản lý số lượng và theo dõi vị trí vật liệu',
      desc: 'Việc nắm bắt chính xác số lượng vật liệu là điều cơ bản. Ngoài ra, hệ thống còn cho phép theo dõi vị trí theo thời gian thực, giúp biết được hiện tại có bao nhiêu vật liệu đang nằm ở vị trí nào.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      video: subVideo1,
    },
    {
      title: 'Xuất/nhập kho tự động',
      desc: 'Khi vật liệu đi qua các điểm kiểm soát nhất định, hệ thống sẽ tự động ghi nhận thông tin xuất hoặc nhập kho. Dữ liệu này có độ chính xác cao, giúp ngăn ngừa sai sót do con người và tiết kiệm nhân lực.',
      sub1: 'Kết nối dữ liệu nhanh chóng',
      icon1: IconTvocGray,
      sub2: 'Theo dõi vị trí thời gian thực',
      icon2: IconBinocularsGray,
      video: subVideo2,
    },
    {
      title: 'Quản lý an toàn',
      desc: 'Các vật liệu tiềm ẩn nguy cơ gây tai nạn cần được quản lý đặc biệt. Không chỉ theo dõi vị trí theo thời gian thực, hệ thống còn phát hiện khi có công nhân đi ngang gần vật liệu đó, từ đó giúp phòng ngừa tai nạn.',
      sub1: 'Thiết lập khoảng cách cảnh báo',
      icon1: IconRulerGray,
      sub2: 'Thiết lập phương án ứng phó',
      icon2: IconBellGray,
      video: subVideo3,
    },
    {
      title: 'Tiết kiệm thời gian',
      desc: 'Giảm thiểu đáng kể thời gian công nhân phải bỏ ra để tìm kiếm vật liệu. Tại công trường, thời gian làm việc chính là năng suất. Hệ thống giúp xây dựng một môi trường làm việc tối ưu, không lãng phí tài nguyên.',
      sub1: 'Nắm bắt tình hình theo thời gian thực',
      icon1: IconClockGray,
      sub2: 'Theo dõi vị trí thời gian thực',
      icon2: IconBinocularsGray,
      video: subVideo4,
    },
    {
      title: 'Ngăn ngừa trộm cắp',
      desc: 'Khi vật liệu bị mất, rất khó xác định là do sơ suất hay bị đánh cắp. Tuy nhiên, nếu biết được vị trí vật liệu theo thời gian thực, có thể ngăn chặn trước những thất thoát không cần thiết về công sức và chi phí.',
      sub1: 'Thiết lập phương án ứng phó',
      icon1: IconBellGray,
      sub2: 'Liên kết với hệ thống bên ngoài',
      icon2: IconChainLinkGray,
      video: subVideo5,
    },
  ],

  subfunc: {
    title: 'Tính năng đa dạng',
    desc: 'Đảm bảo an toàn cho người lao động giúp nâng cao hiệu quả công việc và giảm thiểu thiệt hại do tai nạn. Orbro đã xây dựng các tính năng tối ưu để bảo vệ an toàn cho công nhân tại công trường xây dựng. Hệ thống được thiết kế để ứng phó phù hợp với các sự cố an toàn có thể xảy ra, bao gồm khi công nhân tiếp cận khu vực nguy hiểm, khi tai nạn xảy ra, hoặc các tình huống nguy hiểm tiềm ẩn liên quan đến thiết bị nặng.',
    data: [
      {
        icon: IconChartRadius,
        title: 'Báo cáo và phân tích',
        desc: 'Có thể tạo báo cáo và tài liệu phân tích dựa trên dữ liệu thu thập từ công trường.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo theo thời gian thực',
        desc: 'Khi xảy ra tình huống bất thường, hệ thống sẽ gửi cảnh báo để có thể ứng phó kịp thời.',
      },
      {
        icon: IconRoute,
        title: 'Truy xuất lịch sử di chuyển',
        desc: 'Có thể truy xuất lộ trình di chuyển của vật liệu tại công trường và chuyển thành dữ liệu.',
      },
      {
        icon: IconDashboard,
        title: 'Nắm bắt hiện trạng',
        desc: 'Theo dõi số lượng vật liệu hiện có và vị trí di chuyển của chúng trong thời gian thực.',
      },
      {
        icon: IconWarning,
        title: 'Phát hiện rời khỏi khu vực',
        desc: 'Phát hiện khi vật liệu rời khỏi công trường hoặc di chuyển sai vị trí.',
      },
      {
        icon: IconSearch,
        title: 'Phân tích mô hình lộ trình di chuyển',
        desc: 'Phân tích mức độ sử dụng vật liệu tại công trường và thời điểm chúng được sử dụng.',
      },
      {
        icon: IconChainLink,
        title: 'Tích hợp dữ liệu',
        desc: 'Kết nối hiệu quả với các hệ thống như RFID, IoT, an ninh và camera.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật dữ liệu',
        desc: 'Duy trì mức độ bảo mật dữ liệu cao, đảm bảo cung cấp giải pháp có độ tin cậy vượt trội.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'constructionEquipment' }, { data: 'constructionSafety' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
